/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetNetworkIngressDeleteImpactRequest,
  GetNetworkIngressDeleteImpactSecurity,
} from "../models/operations/getnetworkingressdeleteimpact.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildNetworkIngressGetDeleteImpactQuery,
  NetworkIngressGetDeleteImpactQueryData,
  prefetchNetworkIngressGetDeleteImpact,
  queryKeyNetworkIngressGetDeleteImpact,
} from "./networkIngressGetDeleteImpact.core.js";
export {
  buildNetworkIngressGetDeleteImpactQuery,
  type NetworkIngressGetDeleteImpactQueryData,
  prefetchNetworkIngressGetDeleteImpact,
  queryKeyNetworkIngressGetDeleteImpact,
};

export type NetworkIngressGetDeleteImpactQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getDeleteImpact networkIngress
 *
 * @remarks
 * Count hosted MCP servers that retain dual or private-only modes after ingress deletion.
 */
export function useNetworkIngressGetDeleteImpact(
  request?: GetNetworkIngressDeleteImpactRequest | undefined,
  security?: GetNetworkIngressDeleteImpactSecurity | undefined,
  options?: QueryHookOptions<
    NetworkIngressGetDeleteImpactQueryData,
    NetworkIngressGetDeleteImpactQueryError
  >,
): UseQueryResult<
  NetworkIngressGetDeleteImpactQueryData,
  NetworkIngressGetDeleteImpactQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildNetworkIngressGetDeleteImpactQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getDeleteImpact networkIngress
 *
 * @remarks
 * Count hosted MCP servers that retain dual or private-only modes after ingress deletion.
 */
export function useNetworkIngressGetDeleteImpactSuspense(
  request?: GetNetworkIngressDeleteImpactRequest | undefined,
  security?: GetNetworkIngressDeleteImpactSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    NetworkIngressGetDeleteImpactQueryData,
    NetworkIngressGetDeleteImpactQueryError
  >,
): UseSuspenseQueryResult<
  NetworkIngressGetDeleteImpactQueryData,
  NetworkIngressGetDeleteImpactQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildNetworkIngressGetDeleteImpactQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setNetworkIngressGetDeleteImpactData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: NetworkIngressGetDeleteImpactQueryData,
): NetworkIngressGetDeleteImpactQueryData | undefined {
  const key = queryKeyNetworkIngressGetDeleteImpact(...queryKeyBase);

  return client.setQueryData<NetworkIngressGetDeleteImpactQueryData>(key, data);
}

export function invalidateNetworkIngressGetDeleteImpact(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "networkIngress",
      "getDeleteImpact",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllNetworkIngressGetDeleteImpact(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "networkIngress", "getDeleteImpact"],
  });
}
